import { Button } from '@components';
import { withoutAuth } from '@hoc';
import { Typography, useTheme } from '@mui/material';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Form from './Form';
import { FormContainer, ContentBox, RegistrationBox, TitleBox, LoginBox, PageWrapper, Title, Subtitle, RegistrationSubtitle } from './styles';

const Login: React.FC = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate('/eligibility-check');
  };

  return (
    <PageWrapper>
      <FormContainer>
        <TitleBox>
          <Title variant="h1" color="secondary" sx={{ letterSpacing: '0.5px' }}>
            <FormattedMessage id="common.companyName" />
          </Title>
          <Subtitle variant="h2" color="secondary">
            {/* dangerouslySetInnerHTML is used here in order to highlight with bold font weight some parts of the text */}
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'login.subtitle' }) }} />
          </Subtitle>
        </TitleBox>
        <ContentBox>
          <RegistrationBox>
            <Typography
              variant="h3"
              sx={{ marginBottom: theme.spacing(1), '& > span': { color: theme.palette.primary.main } }}
              dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'login.registration.title' }) }}
            />
            <RegistrationSubtitle>
              <FormattedMessage id="login.registration.subtitle" />
            </RegistrationSubtitle>
            <Typography
              variant="body1"
              sx={{ marginBottom: theme.spacing(4) }}
              dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'login.registration.description' }) }}
            />
            <Button
              variant="contained"
              onClick={handleSignUpClick}
              fullWidth
            >
              <FormattedMessage id="login.button.signUp" />
            </Button>
          </RegistrationBox>
          <LoginBox>
            <Form />
          </LoginBox>
        </ContentBox>
      </FormContainer>
      <Footer />
    </PageWrapper>
  );
};

export default withoutAuth(Login);
